import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ConfirmationBoxText = styled.div`
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    text-align: left;
    padding: 11px 10px;
`;

export const ConfirmationBox = styled.div`
    width: 100%;
    display: flex;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    opacity: 1;
    font-family: AvenirNextWorld Demi;
    margin: 10px 0 30px 0px;
    border-radius: 3px;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    height: 70px;
    ${media.mobileDevice`
        // width: 97%;
        background:  ${({ background }) =>
            background
                ? background
                : '<div id="FFFF"></div> 0% 0% no-repeat padding-box'};
        // height: 100px;
    `};
`;

export const MainContainer = styled.div`
    margin-top: 20px;
    ${media.mobileDevice`
        background: #f5f5f5 0% 0% no-repeat padding-box;
    `};
`;

export const CheckedMessageBox = styled.div`
    display: ${(display) => (display ? display : 'flex')};
    flex-direction: 'column';
    margin: 0 0 32px 7px;
    font-size: 15px;
    font-family: AvenirNextWorld Regular;
    opacity: 0.9;
    letter-spacing: 0px;
    color: #140f4b;
    ${media.largeDevice`
        width: 60%;
    `};
    ${media.mediumDevice`
        width: 85%;
    `};
    ${media.mobileDevice`
        margin:  ${(props) => props.checkedBoxMobileMargin};
    `}
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    //text-align: -webkit-center;
    margin-top: ${(props) => props.marginTop || '100px'};
    // justify-content: flex-end;
    ${media.mobileDevice`
        background: #f5f5f5 0% 0% no-repeat padding-box;
        margin-top:${(props) => props.buttonContainerMarginTop};
        // flex-direction: column;

    `};
`;

export const SubmissionImage = styled.img`
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    background-color: ${(props) => props.isUsagedSubmittedSuccessfully && '#14853d'};
    padding: ${(props) => props.isUsagedSubmittedSuccessfully ? '20px' : '10px 20px 20px 20px'};
    margin-bottom: ${(props) => !props.isUsagedSubmittedSuccessfully && '10px'};
    margin-right: ${(props) => props.isUsagedSubmittedSuccessfully && '24px'};
    ${media.mobileDevice`
        width: 50px;
        padding: 10px;
        height: ${(props) => props.isUsagedSubmittedSuccessfully ? '70px' : '50px'};
    `};
`;

export const SubmissionText = styled.div`
    width: 100%;
    height: 70px;
    padding-top: 5px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 17px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const SubmissionButton = styled.div`
    display: flex;
    justify-content: center;
    ${media.mobileDevice`
        width: 85%
        background: black;
    `};
`;

export const StyledTickImg = styled.img`
    margin-right: 15px;
    margin-top: ${(props) => props.marginTop};
    ${media.mobileDevice`
        margin-right:${(props) => props.mbMarginRight};
    `};
`;

export const PriceOverrideAlert = styled.div`
    margin: ${(props) => (props.margin ? props.margin : '0 0 10px 7px')};
    display: flex;
    ${media.mobileDevice`
        margin:  ${(props) => props.alertMessageMobileMargin};
    `}
`;

export const EmailStyledDiv = styled.div`
    letter-spacing: 0px;
    color: #433f76;
`;

export const Container = styled.div`
    display: flex;
    padding-top: 10px;
    align-items: flex-start;
`;

export const SubContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
